import { Line } from 'vue-chartjs';
export default {
  extends: Line,
  props: ['datasLineChart'],
  data() {
    return {
      gradient: null,
      gradient2: null,
    };
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, 'rgba(255, 196, 30, 0.5)');
    this.gradient.addColorStop(0.5, 'rgba(255, 196, 30, 0.25)');
    this.gradient.addColorStop(1, 'rgba(255, 196, 30, 0)');

    this.gradient2.addColorStop(0, 'rgba(108, 177, 130, 0.9)');
    this.gradient2.addColorStop(0.5, 'rgba(108, 177, 130, 0.25)');
    this.gradient2.addColorStop(1, 'rgba(108, 177, 130, 0)');

    this.renderChart(
      {
        labels: this.getLabels(this.datasLineChart),
        datasets: [
          {
            label: 'Pages vues',
            borderColor: '#FC2525',
            pointBackgroundColor: '#ffc41e',
            pointBorderColor: '#f7981a',
            borderWidth: 0,
            backgroundColor: this.gradient,
            data: this.getViews(this.datasLineChart),
          },
          {
            label: 'Visiteurs',
            borderColor: '#05CBE1',
            pointBackgroundColor: '#70a6b2',
            pointBorderColor: '#4a808c',
            borderWidth: 0,
            backgroundColor: this.gradient2,
            data: this.getVisitors(this.datasLineChart),
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    );
  },
  methods: {
    getLabels(periode) {
      const labels = [];
      for (let i = 0; i < periode.length; i++) {
        labels.push(periode[i].date.slice(0, 10));
      }
      return labels;
    },
    getViews(periode) {
      const datas = [];
      for (let i = 0; i < periode.length; i++) {
        datas.push(periode[i].pageViews);
      }
      return datas;
    },
    getVisitors(periode) {
      const datas = [];
      for (let i = 0; i < periode.length; i++) {
        datas.push(periode[i].visitors);
      }
      return datas;
    },
  },
};
